import { Nullable } from '@qapline/helpers';

export enum EAuthRole {
    System = 'system',
    Admin = 'admin',
    QaplineEmployee = 'qaplineEmployee',
    Dispatcher = 'dispatcher',
    Carrier = 'carrier',
    AttachmentsUploader = 'attachmentsUploader',
    OnboardingUser = 'onboardingUser',
    ApiKeyEnquiryForm = 'apiKeyEnquiryForm',
    ApiKeyAdmin = 'apiKeyAdmin',
    CustomerOwner = 'customerOwner',
    Customer = 'customer',
    CustomerRegistration = 'customerRegistration',
    CustomerUserRegistration = 'customerUserRegistration',
}

export type TAuthTokenPayloadBase = {
    userId: number;
    role: EAuthRole;
    iat: number;
    exp: number;
};

export type TUserAuthTokenPayload = TAuthTokenPayloadBase & {
    number: number;
    name: string;
    surname: string;
    email: string;
    role:
        | EAuthRole.Admin
        | EAuthRole.Dispatcher
        | EAuthRole.Carrier
        | EAuthRole.QaplineEmployee
        | EAuthRole.Customer
        | EAuthRole.CustomerOwner;
};

export type TAttachmentsUploaderAuthTokenPayload = TAuthTokenPayloadBase & {
    commissionId: number;
    commissionQId: string | null;
    role: EAuthRole.AttachmentsUploader;
};

export type TOnboardingUserAuthTokenPayload = TAuthTokenPayloadBase & {
    carrierId: number;
    dispatcherId?: number;
    role: EAuthRole.OnboardingUser;
};

export type TCustomerRegistrationAuthTokenPayload = TAuthTokenPayloadBase & {
    role: EAuthRole.CustomerRegistration;
    customerRegistrationId: number;
    customerId: Nullable<number>;
    customerContactId: Nullable<number>;
};

export type TCustomerUserRegistrationAuthTokenPayload = TAuthTokenPayloadBase & {
    role: EAuthRole.CustomerUserRegistration;
    customerUserId: number;
    invitationId: number;
};

export type TAuthTokenPayload =
    | TUserAuthTokenPayload
    | TAttachmentsUploaderAuthTokenPayload
    | TOnboardingUserAuthTokenPayload;
